import SmartAlertTemplate from '@/components/SmartAlertTemplate';
import { smartAlertPageMap } from '@/data/smartAlertPages';

const page = smartAlertPageMap['emotional-distress'];

if (!page) {
  throw new Error('Smart alert data missing for emotional distress');
}

const SmartAlertEmotionalDistress = () => {
  return <SmartAlertTemplate page={page} />;
};

export default SmartAlertEmotionalDistress;


